import { render } from "./ComFooter.vue?vue&type=template&id=015de930"
import script from "./ComFooter.vue?vue&type=script&lang=js"
export * from "./ComFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__